<template>
  <v-col cols="12" md="3">
    <v-select
        class="input-activation"
        v-model="model"
        :items="plates"
        label="Veículo"
        item-text="plate"
        return-object
        required
    ></v-select>
  </v-col>
</template>

<script>

import axios from "axios";

export default {
  name: "SelectVehicle",
  props: {
    value: {
      default: null,
    },
    look_for_plate: {
      default: null,
    }
  },
  data: function () {
    return {
      plates: [],
    };
  },
  async mounted() {
    this.loading         = true;
    const {data: {data}} = await axios.get('/api/users/driver/me/plate');

    this.plates = data.map(plate => {
      return {
        ...plate.vehicle,
        plate: plate.plate,
      }
    });

    if (this.look_for_plate) {
      const targetPlate = this.plates.find(plate => {
        return plate.plate === this.look_for_plate;
      })

      if (targetPlate) {
        this.model = targetPlate;
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  }
}
</script>

<style scoped>
</style>
